import { HubRoute } from './hub'

export interface LogSuggestions {
    options: SuggestionOption[]
    suggestions: SuggestionOption[]
}

export interface SuggestionOption {
    title: string
    type: SuggestionType
    routes: HubRoute[]
}

export enum SuggestionType {
    Route = 'Route',
    Area = 'Area',
    Workstation = 'Workstation',
    Garage = 'Garage',
}
